import { Pagination, PaginationProps } from "@mui/material";

export type SHPaginationProps = PaginationProps;
export const SHPagination = (props: SHPaginationProps) => {
    return <Pagination {...props} />;
};
